export var packingTagBadgeClassName = 'm-0 rounded-md border-0 px-1.5 py-0.5 text-xs font-semibold leading-[18px]';
export var packingInlineBadgeClassName = 'shrink-0 rounded-md px-1.5 py-0.5 text-xs font-semibold leading-[18px]';
export var packingCountPillClassName = 'rounded-full px-1.5 py-0.5 text-xs font-semibold leading-[18px]';
export var packageStatusBadgeToneClassNames = {
    idle: 'bg-gray-100 text-gray-600 border-gray-200',
    pending: 'bg-orange-50 text-orange-700 border-orange-200',
    open: 'bg-blue-50 text-blue-700 border-blue-200',
    closed: 'bg-green-50 text-green-700 border-green-200'
};
